<template>
  <v-app>
    <div class="ecommerce">
      <template
        v-if="currentProduct && showProductModal && currentProduct.status"
      >
        <template v-if="pageProfile.type == 'forex'">
          <modal-forex-product
            style="min-height: 100vh"
            v-model="currentProduct"
            :key="currentProduct.id"
            :products="allproducts"
            :pageProfile="pageProfile"
            @addToCart="addToCart"
            @close="closeProduct"
            :loading-cart="loadingCart"
          ></modal-forex-product>
        </template>
        <template v-else-if="pageProfile.type == 'runkan'">
          <modal-runkan-product
            style="min-height: 100vh"
            v-model="currentProduct"
            :key="currentProduct.id"
            :products="allproducts"
            :pageProfile="pageProfile"
            @addToCart="addToCart"
            @close="closeProduct"
            :loading-cart="loadingCart"
          ></modal-runkan-product>
        </template>
        <template v-else>
          <template v-if="pageProfile.pageid != '485851741439218'">
            <modal-product
              :categories="filterCategory"
              style="min-height: 100vh"
              v-model="currentProduct"
              :key="currentProduct.id"
              :products="allproducts"
              :pageProfile="pageProfile"
              @addToCart="addToCart"
              @close="closeProduct"
              @openCheckout="openCheckout"
              :loading-cart="loadingCart"
            ></modal-product>
          </template>
          <template v-else>
            <modal-product2
              :categories="filterCategory"
              style="min-height: 100vh"
              v-model="currentProduct"
              :key="currentProduct.id"
              :products="allproducts"
              :pageProfile="pageProfile"
              @addToCart="addToCart"
              @close="closeProduct"
              @openCheckout="openCheckout"
              :loading-cart="loadingCart"
            ></modal-product2>
          </template>
        </template>
      </template>

      <template
        v-else-if="showModal"
        style="min-height: 100vh"
        hide-overlay
        transition="dialog-bottom-transition"
      >
        <v-card class="hide-overflow" style="min-height: 100vh">
          <v-toolbar color="transparent" flat>
            <v-btn
              icon
              @click="close()"
              :disabled="checkoutLoading"
              v-if="!isCDS && pageProfile.type != 'chillpainai'"
            >
              <v-icon>mdi-close</v-icon>
            </v-btn>
            <v-toolbar-title>{{ $t('Checkout Cart') }}</v-toolbar-title>
          </v-toolbar>

          <div :style="{ 'padding-bottom': voucher ? '200px' : '100px' }">
            <template v-if="loadingCart">
              <div class="text-xs-center">
                <v-progress-circular
                  :key="theme.color"
                  indeterminate
                  :color="theme.color"
                ></v-progress-circular>
              </div>
            </template>
            <template v-else-if="cart && filterCart.length > 0">
              <template v-for="(item, index) in filterCart">
                <checkout-item
                  :categories="filterCategory"
                  :key="'cart_' + index + '_' + timestamp"
                  v-model="filterCart[index]"
                  :loading="checkoutLoading"
                  @deleteItem="deleteItemInCart(item)"
                  @onUpdateStock="onUpdateStock"
                  @showProduct="showProduct"
                  :stock="
                    products[item.productid]
                      ? products[item.productid].productstock
                      : []
                  "
                ></checkout-item>
              </template>
            </template>
            <template v-else>
              <div class="text-xs-center pt-4 pb-4">
                <p>{{ $t('No product') }}</p>
              </div>
            </template>
          </div>

          <v-card
            style="position: fixed; z-index: 3; bottom: 0; left: 0; right: 0"
          >
            <!-- <template
              v-if="
                filterCart.length >= 1 &&
                pageProfile &&
                pageProfile.pageid &&
                hasVoucher &&
                !['485851741439218'].includes(pageProfile.pageid)
              "
            >
              <voucher-code
                v-model="voucherCode"
                :pageid="pageProfile.pageid"
                @onUpdateTotal="onUpdateTotal"
              ></voucher-code>
            </template> -->
            <v-layout wrap>
              <template v-if="filterCart.length >= 1">
                <v-flex xs4 class="pl-3 pr-3 pt-2 pb-2">{{
                  $t('Total')
                }}</v-flex>
                <v-flex xs8 class="pl-3 pr-3 pt-2 pb-2 text-xs-right"
                  >{{ currencySign }}{{ totalPrice | decimalFormat }}</v-flex
                >
              </template>
              <v-flex xs12>
                <template v-if="isCartOutOfStock">
                  <!-- <template v-if="cart.length < 1 || isCartOutOfStock"> -->
                  <div class="text-xs-center pa-3 grey lighten-2">
                    <span>
                      {{
                        $t(
                          'Not enough products in stock, please try to order again.'
                        )
                      }}
                    </span>
                  </div>
                </template>
                <template v-else-if="isTotalMinimum">
                  <!-- <template v-if="cart.length < 1 || isCartOutOfStock"> -->
                  <div class="text-xs-center pa-3 grey lighten-2">
                    <span>
                      {{ $t('Please order a minimum amount of') }}
                      {{ minimumPrice }}
                      {{ $t('baht') }}
                    </span>
                  </div>
                </template>
                <v-btn
                  v-else
                  depressed
                  large
                  dark
                  ripple
                  :color="theme.color"
                  :loading="
                    loadingCart || checkoutLoading || loadingPageProfile
                  "
                  @click="checkout(true)"
                  class="ma-0"
                  :disabled="isCartOutOfStock || isTotalMinimum"
                  style="width: 100%; border-radius: 0px; height: 55px"
                  :style="{
                    'padding-bottom': $store.getters.getIosPadding
                      ? '15px'
                      : '0'
                  }"
                >
                  <v-icon>mdi-cart-plus</v-icon>&nbsp;
                  <template v-if="$store.state.cds.includes(pageid)"
                    >OK</template
                  >
                  <template v-else>{{ $t('Proceed Checkout') }}</template>
                </v-btn>
              </v-flex>
            </v-layout>
          </v-card>
        </v-card>
      </template>

      <div v-show="!showProductModal && !showModal">
        <div class="container" v-if="productLoading">
          <sync-loader
            :key="theme.color"
            :color="theme.color"
            :size="'10px'"
            style="
              position: absolute;
              top: 50%;
              margin-top: -10px;
              left: 50%;
              margin-left: -21px;
            "
          ></sync-loader>
        </div>
        <template v-else>
          <div v-show="!isCDS && pageProfile.type != 'chillpainai'">
            <merchant-detail
              v-model="pageProfile"
              id="merchant"
              :salePageShopName="salePageShopName"
              :salePageIsActive="salePageIsActive"
            >
              <template v-if="!salePageIsActive">
                <template slot="category">
                  <v-tabs
                    show-arrows
                    v-model="selectedCategory"
                    :slider-color="theme.color"
                    @change="onChangeCategory"
                    active-class="v-tabs__item--active primary lighten-3 white--text"
                  >
                    <template
                      v-if="!['nvbb', 'alice'].includes(pageProfile.type)"
                    >
                      <v-tab
                        @touchstart="selectedCategory = 'all'"
                        :key="'category_all'"
                        :href="'#all'"
                        >{{ $t('All') }}</v-tab
                      >
                      <v-tab
                        @touchstart="selectedCategory = 'sales'"
                        v-if="hasSaleCategory"
                        :key="'category_sales'"
                        :href="'#sales'"
                      >
                        {{ $t('Sale') }}
                      </v-tab>
                    </template>
                    <template v-for="(category, cindex) in filterCategory">
                      <template v-if="category.productCount > 0">
                        <v-tab
                          show-arrows
                          :key="'category_' + cindex"
                          :href="'#' + category.id"
                          @touchstart="
                            selectedCategory = JSON.stringify(category.id)
                          "
                          ripple
                          >{{ category.name }}</v-tab
                        >
                      </template>
                    </template>
                    <template
                      v-if="['nvbb', 'alice'].includes(pageProfile.type)"
                    >
                      <v-tab
                        :key="'category_all'"
                        @touchstart="selectedCategory = 'all'"
                        :href="'#all'"
                        >{{ $t('All') }}</v-tab
                      >
                      <v-tab
                        v-if="hasSaleCategory"
                        @touchstart="selectedCategory = 'sales'"
                        :key="'category_sales'"
                        :href="'#sales'"
                      >
                        {{ $t('Sale') }}
                      </v-tab>
                    </template>
                  </v-tabs>
                </template>
                <template slot="search">
                  <v-text-field
                    ref="search"
                    :color="theme.color"
                    v-if="showSearch"
                    :placeholder="
                      selectedCategory == 'all'
                        ? $t('Search all')
                        : $t('Search in {category}', {
                            category: currentCategory
                              ? currentCategory.name.replace(/\<|\>/g, '')
                              : ''
                          })
                    "
                    v-model="search"
                  ></v-text-field>
                  <v-btn icon @click="openSearch">
                    <v-icon v-if="!showSearch">mdi-magnify</v-icon>
                    <v-icon v-else>mdi-close</v-icon>
                  </v-btn>
                </template>
              </template>
            </merchant-detail>

            <v-content
              class="mb-5"
              :style="salePageIsActive ? 'padding: 48px 0px 0px;' : ''"
            >
              <v-container
                v-if="salePageIsActive"
                fluid
                grid-list-md
                :class="salePageIsActive ? 'pt-0 pl-0 pr-0' : ''"
              >
                <v-alert
                  :value="true"
                  v-if="
                    pageProfile && $store.state.cds.includes(pageProfile.pageid)
                  "
                  color="info"
                  icon="info"
                  outline
                  >กรุณากดปุ่ม "สรุปยอดสินค้า/Checkout" ด้านล่าง
                  เพื่อยืนยันการสั่งซื้อ</v-alert
                >

                <!-- Preview Sale Page -->

                <div v-if="salePageIsActive">
                  <template v-for="(item, i) in salePage.template">
                    <div
                      :key="`slideshow_${i}`"
                      v-if="item.type === 'slideshow'"
                      :style="`background: ${item.color.hex}`"
                    >
                      <template>
                        <v-carousel
                          hide-delimiters
                          height="auto"
                          style="box-shadow: none"
                          :style="`${
                            windowWidth > 1024 ? 'padding: 1% 30%;' : ''
                          }`"
                        >
                          <v-carousel-item
                            v-for="(image, i) in item.images"
                            :key="`carousel_${i}`"
                            :src="image ? image : ''"
                          ></v-carousel-item>
                        </v-carousel>
                      </template>
                    </div>
                    <div
                      style="text-align: -webkit-center"
                      class="pb-3 pa-3"
                      :key="`message_readonly_${i}`"
                      v-if="item.type === 'message'"
                      :style="`background: ${item.color.hex}`"
                    >
                      <message
                        v-model="item.value"
                        :index="`readonly-${i}`"
                        :readonly="true"
                      ></message>
                    </div>
                    <div
                      class="pb-3"
                      style="padding: 10px"
                      :key="`productlist_${i}`"
                      v-if="item.type === 'productlist'"
                      :style="`background: ${item.color.hex}`"
                    >
                      <v-layout row wrap v-if="item.option === 'btn'">
                        <v-flex xs6>
                          <template>
                            <v-btn
                              style="width: -webkit-fill-available"
                              :style="
                                selectedCategory === 'all'
                                  ? `background:${item.borderColor.hex} !important; color:#FFFFFF ; border-color:${item.borderColor.hex}`
                                  : ''
                              "
                              outline
                              :color="item.borderColor.hex"
                              @click="clickSelectedCategory(`all`)"
                            >
                              All
                            </v-btn>
                          </template>
                        </v-flex>
                        <v-flex xs6 v-if="hasSaleCategory">
                          <template>
                            <v-btn
                              style="width: -webkit-fill-available"
                              :style="
                                selectedCategory === 'sales'
                                  ? `background:${item.borderColor.hex} !important; color:#FFFFFF ; border-color:${item.borderColor.hex} `
                                  : ''
                              "
                              outline
                              :color="item.borderColor.hex"
                              @click="clickSelectedCategory(`sales`)"
                            >
                              Sale
                            </v-btn>
                          </template>
                        </v-flex>
                        <template v-for="(category, cindex) in filterCategory">
                          <v-flex
                            xs6
                            :key="'category_' + cindex"
                            v-if="category.productCount > 0"
                          >
                            <template>
                              <v-btn
                                class="truncate"
                                style="width: -webkit-fill-available"
                                :style="
                                  selectedCategory === `${category.id}`
                                    ? `background:${item.borderColor.hex} !important; color:#FFFFFF ; border-color:${item.borderColor.hex}`
                                    : ''
                                "
                                outline
                                :color="item.borderColor.hex"
                                @click="clickSelectedCategory(`${category.id}`)"
                              >
                                {{ category.name }}
                              </v-btn>
                            </template>
                          </v-flex>
                        </template>
                      </v-layout>
                      <div
                        style="display: flex; overflow: auto"
                        class="mb-2"
                        v-if="item.option === 'image'"
                      >
                        <v-flex>
                          <v-card
                            class="ml-2 mr-2"
                            style="width: 150px; cursor: pointer"
                            @click="clickSelectedCategory(`all`)"
                          >
                            <v-responsive :aspect-ratio="1">
                              <div
                                :style="`background-size:contain;background-image: url('${item.images[0]['0']}');height: 100%;background-position: center;background-size: cover;`"
                              ></div>
                            </v-responsive>
                            <div
                              class="pa-2"
                              :style="
                                selectedCategory === 'all'
                                  ? `background:${theme.color} !important; color:#FFFFFF ; border-color:${theme.color}`
                                  : ''
                              "
                            >
                              {{ $t('All') }}
                            </div>
                          </v-card>
                        </v-flex>
                        <v-flex v-if="hasSaleCategory">
                          <v-card
                            class="ml-2 mr-2"
                            style="width: 150px; cursor: pointer"
                            @click="clickSelectedCategory(`sales`)"
                          >
                            <v-responsive :aspect-ratio="1">
                              <div
                                :style="`background-size:contain;background-image: url('${item.images[1]['1']}');height: 100%;background-position: center;background-size: cover;`"
                              ></div>
                            </v-responsive>
                            <div
                              class="pa-2"
                              :style="
                                selectedCategory === 'sales'
                                  ? `background:${theme.color} !important; color:#FFFFFF ; border-color:${theme.color} `
                                  : ''
                              "
                            >
                              {{ $t('Sale') }}
                            </div>
                          </v-card>
                        </v-flex>
                        <template v-for="(category, i) in filterCategory">
                          <v-flex v-if="category.productCount > 0" :key="i">
                            <v-card
                              class="ml-2 mr-2"
                              style="width: 150px; cursor: pointer"
                              @click="clickSelectedCategory(category.id)"
                            >
                              <v-responsive :aspect-ratio="1">
                                <div
                                  :style="`background-size:contain;background-image: url('${
                                    item.images && item.images[i]
                                      ? item.images[i][category.id]
                                      : null
                                  }');height: 100%;background-position: center;background-size: cover;`"
                                ></div>
                              </v-responsive>
                              <div
                                class="pa-2"
                                :style="
                                  selectedCategory === `${category.id}`
                                    ? `background:${theme.color} !important; color:#FFFFFF ; border-color:${theme.color}`
                                    : ''
                                "
                              >
                                {{ category.name }}
                              </div>
                            </v-card>
                          </v-flex>
                        </template>
                      </div>
                      <merchant-detail
                        v-if="item.option === 'tab'"
                        v-model="pageProfile"
                        id="merchant"
                        :showSearch="true"
                        :disableToolbar="true"
                        :salePageIsActive="salePageIsActive"
                      >
                        <template slot="category">
                          <v-layout row wrap>
                            <v-flex xs11>
                              <v-tabs
                                v-if="!showSearch"
                                show-arrows
                                v-model="selectedCategory"
                                :slider-color="theme.color"
                                @change="onChangeCategory"
                                active-class="v-tabs__item--active primary lighten-3 white--text"
                              >
                                <template v-if="pageProfile.type != 'nvbb'">
                                  <v-tab
                                    @touchstart="selectedCategory = 'all'"
                                    :key="'category_all'"
                                    :href="'#all'"
                                    >{{ $t('All') }}</v-tab
                                  >
                                  <v-tab
                                    v-if="hasSaleCategory"
                                    :key="'category_sales'"
                                    @touchstart="selectedCategory = 'sales'"
                                    :href="'#sales'"
                                  >
                                    {{ $t('Sale') }}
                                  </v-tab>
                                </template>
                                <template
                                  v-for="(category, cindex) in filterCategory"
                                >
                                  <template v-if="category.productCount > 0">
                                    <v-tab
                                      show-arrows
                                      :key="'category_' + cindex"
                                      @touchstart="
                                        selectedCategory = JSON.stringify(
                                          category.id
                                        )
                                      "
                                      :href="'#' + category.id"
                                      ripple
                                      >{{
                                        category.display_name
                                          ? category.display_name
                                          : category.name
                                      }}</v-tab
                                    >
                                  </template>
                                </template>
                                <template v-if="pageProfile.type == 'nvbb'">
                                  <v-tab
                                    @touchstart="selectedCategory = 'all'"
                                    :key="'category_all'"
                                    :href="'#all'"
                                    >{{ $t('All') }}</v-tab
                                  >
                                  <v-tab
                                    v-if="hasSaleCategory"
                                    :key="'category_sales'"
                                    @touchstart="selectedCategory = 'sales'"
                                    :href="'#sales'"
                                  >
                                    {{ $t('Sale') }}
                                  </v-tab>
                                </template>
                              </v-tabs>
                              <v-text-field
                                ref="searchProduct"
                                :color="theme.color"
                                v-show="showSearch"
                                :placeholder="
                                  selectedCategory == 'all'
                                    ? $t('Search all')
                                    : $t('Search in {category}', {
                                        category: currentCategory
                                          ? currentCategory.name.replace(
                                              /\<|\>/g,
                                              ''
                                            )
                                          : ''
                                      })
                                "
                                v-model="search"
                              ></v-text-field>
                            </v-flex>
                            <v-flex xs1>
                              <div>
                                <v-btn icon @click="openSearch">
                                  <v-icon v-if="!showSearch"
                                    >mdi-magnify</v-icon
                                  >
                                  <v-icon v-else>mdi-close</v-icon>
                                </v-btn>
                              </div>
                            </v-flex>
                          </v-layout>
                        </template>
                      </merchant-detail>
                      <v-layout wrap row>
                        <template v-if="filterProducts.length > 0">
                          <template v-for="(product, pindex) in filterProducts">
                            <product
                              :key="'product_' + filterProducts[pindex].id"
                              v-model="filterProducts[pindex]"
                              @selectProduct="
                                onSelectProduct(filterProducts[pindex])
                              "
                            ></product>
                          </template>
                          <v-flex xs12>
                            <div class="text-xs-center mt-4 mb-4">
                              <v-pagination
                                :color="theme.color"
                                v-model="pageNumber"
                                :length="pageCount"
                              ></v-pagination>
                            </div>
                          </v-flex>
                        </template>
                        <template v-else>
                          <div class="text-xs-center" style="margin: 25px auto">
                            <img
                              src="../assets/img/ecommerce/empty_shopping_cart@4x.png"
                              alt
                              style="width: 100px; margin-bottom: 10px"
                            />
                            <h4>{{ $t('No product') }}</h4>
                          </div>
                        </template>
                      </v-layout>
                    </div>
                    <div
                      class="pb-3 text-xs-center"
                      style="padding: 10px"
                      :key="`productslect_${i}`"
                      v-if="item.type === 'productslect'"
                      :style="`background: ${item.color.hex}`"
                    >
                      <h5
                        style="padding: 16px 10px; font-size: 1.64rem"
                        :style="`color:${theme.color}`"
                      >
                        {{ item.titleName }}
                      </h5>
                      <v-layout wrap row>
                        <template v-if="filterProducts.length > 0">
                          <template
                            v-for="(product, pindex) in filterProductsList(
                              item.productSelect
                            )"
                          >
                            <product
                              :key="
                                'product_slect' +
                                filterProductsList(item.productSelect)[pindex]
                                  .id
                              "
                              v-model="
                                filterProductsList(item.productSelect)[pindex]
                              "
                              @selectProduct="
                                onSelectProduct(
                                  filterProductsList(item.productSelect)[pindex]
                                )
                              "
                            ></product>
                          </template>
                          <v-flex xs12>
                            <div class="text-xs-center mt-4 mb-4">
                              <!-- <v-pagination
                                :color="theme.color"
                                v-model="pageNumber"
                                :length="pageCount"
                              ></v-pagination> -->
                            </div>
                          </v-flex>
                        </template>
                        <template v-else>
                          <div class="text-xs-center" style="margin: 25px auto">
                            <img
                              src="../assets/img/ecommerce/empty_shopping_cart@4x.png"
                              alt
                              style="width: 100px; margin-bottom: 10px"
                            />
                            <h4>{{ $t('No product') }}</h4>
                          </div>
                        </template>
                      </v-layout>
                    </div>
                    <div
                      :key="`photo_${i}`"
                      v-if="item.type === 'photo'"
                      :style="`background: ${item.color.hex} ; ${
                        windowWidth > 1024
                          ? item.padding
                            ? 'padding: 1% 30%;'
                            : 'padding: 0% 30%;'
                          : item.padding
                          ? 'padding: 10px'
                          : ''
                      }`"
                    >
                      <template v-if="item.image[0]">
                        <v-img
                          @click="openNewtab(item.url)"
                          :style="item.url ? 'cursor: pointer' : ''"
                          :src="item.image[0]"
                          :aspect-ratio="item.option == '2to1' ? 16 / 9 : 1"
                          color="grey"
                        ></v-img>
                      </template>
                    </div>

                    <div
                      class="pb-3"
                      style="text-align: -webkit-center; padding: 10px"
                      :style="`background: ${item.color.hex}`"
                      :key="`youtube_${i}`"
                      v-if="item.type === 'youtube'"
                    >
                      <v-layout wrap>
                        <v-flex
                          style="height: 320px"
                          xs12
                          sm8
                          offset-sm2
                          md6
                          offset-md3
                          lg6
                          offset-lg3
                          xl4
                          offset-xl4
                        >
                          <iframe
                            style="width: 100%; height: 100%"
                            :id="`ytplayer_`"
                            type="text/html"
                            allow="autoplay"
                            :src="`https://www.youtube.com/embed/${
                              item.url
                            }?autoplay=${item.autoplay ? '1' : '0'}&playlist=${
                              item.url
                            }&loop=${item.loop ? '1' : '0'}&mute=1`"
                            frameborder="0"
                          ></iframe>
                        </v-flex>
                      </v-layout>
                    </div>
                    <div
                      style="text-align: -webkit-center; padding: 10px"
                      :style="`background: ${item.color.hex}`"
                      :key="`socialLink_${i}`"
                      v-if="item.type === 'socialLink'"
                    >
                      <v-layout wrap>
                        <v-flex
                          xs12
                          sm8
                          offset-sm2
                          md6
                          offset-md3
                          lg6
                          offset-lg3
                          xl4
                          offset-xl4
                        >
                          <h2
                            class="mb-1"
                            :style="`color:${pageProfile.shopcolor}`"
                          >
                            {{ item.titleName }}
                          </h2>
                          <template v-for="(data, index) in item.list">
                            <div
                              @click="openNewtab(data.url)"
                              v-if="data.status"
                              :key="index"
                              class="intent-item z-border-red pa-1 text-xs-left"
                              style="max-height: 52px; cursor: pointer"
                              :style="`border-color:${
                                data.borderColor ? data.borderColor.hex : '#000'
                              }`"
                            >
                              <v-layout wrap>
                                <v-flex xs3 class="text-xs-center pa-1">
                                  <img :src="data.image" alt="" height="40" />
                                </v-flex>
                                <v-flex xs9 style="align-self: center">
                                  <span
                                    :style="`font-size: 19px; color:${
                                      data.fontColor
                                        ? data.fontColor.hex
                                        : '#000'
                                    }`"
                                    >{{ data.title }}</span
                                  >
                                </v-flex>
                              </v-layout>
                            </div>
                          </template>
                        </v-flex>
                      </v-layout>
                    </div>
                  </template>
                </div>
                <!-- Preview Sale Page -->
                <!-- {{ userAgent }} -->

                <v-layout wrap row v-else>
                  <template v-if="filterProducts.length > 0">
                    <template v-for="(product, pindex) in filterProducts">
                      <product
                        :key="'product_' + filterProducts[pindex].id"
                        v-model="filterProducts[pindex]"
                        @selectProduct="onSelectProduct(filterProducts[pindex])"
                      ></product>
                    </template>
                    <v-flex xs12>
                      <div class="text-xs-center mt-4 mb-4">
                        <v-pagination
                          :color="theme.color"
                          v-model="pageNumber"
                          :length="pageCount"
                        ></v-pagination>
                      </div>
                    </v-flex>
                  </template>
                  <template v-else>
                    <div class="text-xs-center" style="margin: 25px auto">
                      <img
                        src="../assets/img/ecommerce/empty_shopping_cart@4x.png"
                        alt
                        style="width: 100px; margin-bottom: 10px"
                      />
                      <h4>{{ $t('No product') }}</h4>
                    </div>
                  </template>
                </v-layout>
                <div
                  class="text-xs-center"
                  style="padding-top: 15px; padding-bottom: 15px"
                >
                  <a
                    href="javascript:void(0);"
                    @click="openTerm()"
                    style="color: rgb(169, 169, 169)"
                    >{{ $t('Terms & Condition & Refund Prolicy') }}.</a
                  >
                </div>
              </v-container>
              <div v-else>
                <v-alert :value="true" type="warning">
                  {{ $t('Sales page is not active this page.') }}
                </v-alert>
              </div>
            </v-content>
            <div
              id="filter"
              class="filter"
              style="
                background: white;
                overflow: auto;
                border-top: 1px solid #eee;
              "
              v-if="false"
            >
              <div id="container" class="container">
                <div style="display: flex">
                  <div
                    id="categories"
                    class="categories"
                    v-if="!showSearch"
                    style="flex: 1 1 40%"
                    :class="{ 'hidden-xs': showSearch }"
                    :style="{ width: categoriesWidth }"
                  >
                    <ul class="list">
                      <li>
                        <a
                          href="javascript:void(0);"
                          class="btn"
                          @click="clickSelectedCategory('all')"
                          :class="{
                            'btn-primary': selectedCategory == 'all',
                            'btn-default': selectedCategory != 'all'
                          }"
                          >{{ $t('All') }}</a
                        >
                      </li>
                      <li>
                        <a
                          href="javascript:void(0);"
                          class="btn"
                          @click="clickSelectedCategory('sales')"
                          :class="{
                            'btn-primary': selectedCategory == 'sales',
                            'btn-default': selectedCategory != 'sales'
                          }"
                          >{{ $t('Sale') }}</a
                        >
                      </li>
                      <template v-for="(category, cindex) in filterCategory">
                        <li
                          :key="'category_' + cindex"
                          v-if="category.productCount > 0"
                        >
                          <a
                            href="javascript:void(0);"
                            class="btn"
                            @click="clickSelectedCategory(category.id)"
                            :class="{
                              'btn-primary': selectedCategory == category.id,
                              'btn-default': selectedCategory != category.id
                            }"
                            >{{ category.name }}</a
                          >
                        </li>
                      </template>
                    </ul>
                  </div>

                  <div
                    id="search-btn"
                    style="
                      position: relative;
                      display: inline-block;
                      padding: 15px;
                      font-size: 18px;
                      margin-top: 5px;
                    "
                  >
                    <a href="javascript:void(0);" style @click="openSearch()">
                      <span
                        class="glyphicon"
                        :class="{
                          'glyphicon-search': !showSearch,
                          'glyphicon-remove': showSearch
                        }"
                      ></span>
                    </a>
                  </div>

                  <div
                    class="search-container"
                    v-if="showSearch"
                    style="width: 100%"
                  >
                    <span class="clearable" style="width: 100%">
                      <input
                        type="text"
                        class="form-control"
                        ref="search"
                        v-model="search"
                        :placeholder="$t('Search')"
                      />
                      <i
                        class="clearable__clear"
                        :class="{ show: search != '' }"
                        @click="search = ''"
                        >&times;</i
                      >
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <div class="clearfix"></div>

            <template
              v-if="!['forex', 'ros', 'runkan'].includes(pageProfile.type)"
            >
              <v-bottom-nav
                :value="true"
                :color="theme.color"
                dark
                style="height: 68px; z-index: 3"
                :style="{
                  'padding-bottom': $store.getters.getIosPadding ? '15px' : '0',
                  position:
                    salePage && salePage.checkoutBtn === 'fixed'
                      ? 'fixed'
                      : 'absolute'
                }"
              >
                <v-btn
                  style="max-width: 100%"
                  flat
                  value="nearby"
                  @click="openModal"
                >
                  <span>{{ $t('Checkout') }} </span>
                  <v-badge color="red">
                    <template v-slot:badge v-if="totalItem > 0">
                      <span>{{ totalItem }}</span>
                    </template>
                    <v-icon>mdi-cart-plus</v-icon>
                  </v-badge>
                </v-btn>
              </v-bottom-nav>
            </template>
          </div>
        </template>

        <!-- <div
          :style="{ 'background-color': theme.color }"
          style="position: fixed;bottom: 0; left: 0; right: 0;"
        >

        </div>-->
      </div>

      <Loading v-if="checkoutLoading"></Loading>

      <v-dialog :value="showRedirectToSocial" max-width="400">
        <v-card>
          <v-card-title>
            <span class="headline" :style="{ color: theme.color }">
              {{ $route.query.testbot ? 'หมายเหตุ' : $t('Login to checkout') }}
            </span>
            <v-spacer></v-spacer>
            <v-btn flat fab small @click="showRedirectToSocial = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-card-title>

          <v-card-text :class="$route.query.testbot ? 'pt-0' : ''">
            <div class="text-xs-center">
              <div v-if="!$route.query.testbot">
                <v-btn
                  :href="redirecturl"
                  :color="'#2975eb'"
                  dark
                  class="mb-4"
                  large
                >
                  <img
                    src="../assets/img/social/icon-facebook.png"
                    alt="facebook button"
                    style="width: 16px; margin-right: 10px"
                  />
                  <span>{{ $t('Sign in with Facebook') }}</span>
                </v-btn>
              </div>
              <div v-else>
                ในส่วนนี้ใช้สำหรับในการทดสอบบอทเบื้องต้นเท่านั้น
                หากต้องการทดสอบการสั่งซื้ออย่างเต็มรูปแบบ
                สามารถทดสอบผ่านทางกล่องข้อความของเพจ
              </div>
            </div>
          </v-card-text>
        </v-card>
      </v-dialog>

      <term-and-condition
        :pageid="pageProfile.pageid"
        v-if="showTerm"
        @close="closeTerm()"
      ></term-and-condition>

      <v-dialog v-model="showShop" max-width="600" persistent>
        <v-card>
          <v-card-text>
            <div class="text-xs-center mb-2">
              เลือกร้านจากจุดบนแผนที่เพื่อหาร้านที่ใกล้ที่สุด
            </div>
            <gmap-near-shop
              v-if="showmap"
              :showRadius="true"
              :placesinfo="placesinfolabel"
              v-validate="{ required: true }"
              name="ปักหมุดที่อยู่"
              v-model="gmapvalue"
              v-on:input="gmapLocation"
              :lastordercoords="lastordercoords"
              :error="errors.has('ปักหมุดที่อยู่')"
              :shoplocation="branchlocation"
              :radius="1000"
              :radiusColor="theme.color"
            ></gmap-near-shop>
            <div class="mb-2"></div>

            <div class="text-xs-center">ร้าน {{ shop }} ใกล้คุณที่สุด</div>
            <div class="text-xs-center">
              <v-btn
                @click="selectShop"
                :color="theme.color"
                depressed
                dark
                :loading="loadingmap"
                >เลือก</v-btn
              >
            </div>
          </v-card-text>
        </v-card>
      </v-dialog>
    </div>
  </v-app>
</template>

<script>
import { mapGetters } from 'vuex'

import config from '@/config'
import axios from 'axios'
import SyncLoader from 'vue-spinner/src/SyncLoader.vue'

import CheckoutItem from '@/components/ecommerce/CheckoutItem.vue'
import ModalCheckout from '@/components/ecommerce/ModalCheckout.vue'
import Product from '@/components/ecommerce/Product.vue'
import Loading from '@/components/Loading.vue'
import Modal from '@/components/Modal.vue'

import TermAndCondition from '@/components/ecommerce/TermAndCondition.vue'

import GmapNearShop from '@/components/ecommerce/GmapNearShop.vue'
import MerchantDetail from '@/components/ecommerce/MerchantDetail'
import ModalForexProduct from '@/components/ecommerce/ModalForexProduct.vue'
import ModalProduct from '@/components/ecommerce/ModalProduct.vue'
import ModalProduct2 from '@/components/ecommerce/ModalProduct2.vue'
import ModalRunkanProduct from '@/components/ecommerce/ModalRunkanProduct.vue'
import VoucherCode from '@/components/ecommerce/VoucherCode.vue'
import moment from 'moment'

import Message from '@/components/salepage/templateType/Message.vue'

export default {
  data: function () {
    return {
      windowWidth: window.innerWidth,
      userAgent: '',
      currentProduct: null,
      // pageid: null,
      userid: null,
      categories: [],
      products: {},
      productlist: [],

      shop: null,
      showShop: false,

      showmap: false,
      gmapvalue: '',

      shopOptions: [
        'Sukhumvit 49',
        'Surawong',
        'Panya Village',
        'Villa Aree',
        'Samyan Mitr Town (G Flr)',
        'Siam Paragon (G Flr)',
        'Central Ladplao (B Flr)',
        'Central Changwattana',
        'Central Eastville (G Flr)',
        'Central Rama 9 (B Flr)',
        'The Circle Rachapruk',
        'SB Rachapruk',
        'Dentral Hospital',
        'The Cystral Ekkamai-Ramindra',
        'Central Westgate',
        'The Mall Bangkapi',
        'PTT Aomnoi',
        'PTT Puttasakorn (Arrival)',
        'PTT Puttasakorn (Departure)'
      ],

      selectedCategory: 'all',
      tmpSelectedCategory: 'all',

      showModal: false,
      showProductModal: false,
      showRedirectToSocial: false,
      showAlert: false,
      showTerm: false,
      showBox: false,
      showDelete: false,
      showSearch: false,

      productLoading: true,
      checkoutLoading: false,
      profileLoading: false,

      redirecturl: null,

      pageid: null,
      // pageProfile: null,
      config: {
        color: config.color
      },
      sessiontoken: null,
      loadingCart: true,

      deleteIndex: null,

      scrollY: null,

      search: '',
      categoriesWidth: '0px',
      pageNumber: 1,
      productCount: 0,
      size: 20,
      voucherCode: null,
      voucher: null,
      text: '',
      timestamp: moment().format('x'),
      hasSaleCategory: false,
      allproducts: [],
      placesinfo: '',
      ggmapdistance: null,
      lastordercoords: null,
      loadingmap: true,
      ableToShipping: false,
      kanomshippingprice: 0,
      hasVoucher: false,
      salePage: null,
      salePageIsActive: false,
      salePageShopName: ''
    }
  },
  computed: {
    placesinfolabel() {
      return (
        this.placesinfo +
        ` (${this.ggmapdistance ? this.ggmapdistance.distance : 0} Km)` +
        `<div style="margin-top: 5px;border-radius: 5px;padding: 5px; color: white; background: ${
          this.ableToBuy ? 'green' : 'red'
        }">${
          this.ableToBuy
            ? ` ค่าส่ง ${this.customShippingPrice} บาท`
            : ' ไม่สามารถจัดส่งได้'
        }</div>` +
        `<div class="mt-2">หรือรับที่ร้านฟรีค่าจัดส่ง</div>`
      )
    },
    ableToBuy() {
      return this.ableToShipping
    },
    customShippingPrice() {
      return this.kanomshippingprice
    },
    filterCategory() {
      const vm = this
      if (!vm.categories) {
        return []
      }
      if (vm.pageProfile && vm.pageProfile.type == 'kanom') {
        var categories = vm.categories
          .filter((el) => {
            return el.name.includes(vm.shop)
          })
          .map((el) => {
            var cat = { ...el }
            cat.name = cat.name.replace(vm.shop + '/', '')
            return cat
          })
        return categories
      } else {
        vm.categories = vm.categories.filter((el) => {
          if (vm.pageProfile && !vm.pageProfile.zortout_is_active) {
            return el.ref_code !== 'ZORTOUT' && !el.is_hidden
          }
          return !el.is_hidden
        })
        vm.categories.forEach((item, i) => {
          if (item.name === 'ZORTOUT-BUNDLE') {
            vm.categories.splice(i, 1)
            vm.categories.unshift(item)
          }
        })
        return vm.categories
      }
    },
    ...mapGetters({
      cart: 'getCart',
      isWholesale: 'getWholesaleStatus',
      wholesale: 'getWholesale',
      currentLang: 'currentLang',
      loadingPageProfile: 'getLoadingPageProfile',
      pageProfile: 'getPageProfile',
      theme: 'getTheme',
      getSalePage: 'getSalePage',
      currencySign: 'currencySign'
    }),
    filterCart() {
      if (this.pageProfile && this.pageProfile.type == 'kanom') {
        return this.cart.filter((el) => {
          return (
            this.filterCategory.findIndex((cat) => {
              return cat.id == el.categoryid
            }) != -1
          )
        })
      } else {
        return this.cart
      }
    },
    totalItem() {
      return this.filterCart.length > 0
        ? this.filterCart
            .map((el) => {
              return parseInt(el.quantity)
            })
            .reduce((prev, cur) => {
              return prev + cur
            })
        : 0
    },
    isKhaiwhan() {
      return (
        this.pageProfile &&
        this.$store.state.khaiwhan.includes(this.pageProfile.pageid)
      )
    },
    currencySign: function () {
      const vm = this
      if (
        vm.pageProfile &&
        vm.$store.state.usdCurrency.includes(vm.pageProfile.pageid)
      ) {
        return '$'
      } else if (
        vm.pageProfile &&
        vm.$store.state.myanmarCurrency.includes(vm.pageProfile.pageid)
      ) {
        return 'K'
      } else if (
        vm.pageProfile &&
        vm.$store.state.wonCurrency.includes(vm.pageProfile.pageid)
      ) {
        return '₩'
      } else if (
        vm.pageProfile &&
        vm.$store.state.kipCurrency.includes(vm.pageProfile.pageid)
      ) {
        return '₭'
      } else if (
        vm.pageProfile &&
        vm.$store.state.poundCurrency.includes(vm.pageProfile.pageid)
      ) {
        return '£'
      } else if (
        vm.pageProfile &&
        vm.$store.state.tkBangladeshCurrency.includes(vm.pageProfile.pageid)
      ) {
        return '৳'
      } else {
        return '฿'
      }
    },

    pageCount: function () {
      let l = this.productCount
      let s = this.size
      return Math.ceil(l / s)
    },
    pagename: function () {
      return this.$route.query.pageid
        ? this.$route.query.pageid
        : this.$route.params.id
        ? this.$route.params.id
        : undefined
    },
    filterProducts: function () {
      let vm = this
      var filteredProducted = vm.onFilterProducts()

      filteredProducted = filteredProducted.filter((el) => {
        if (vm.pageProfile && !vm.pageProfile.zortout_is_active) {
          if (el.ref_code) {
            return !el.ref_code.includes('ZORTOUT')
          }
        }
        return el
      })
      vm.productCount = filteredProducted.length

      const start = (vm.pageNumber - 1) * vm.size
      const end = start + vm.size

      return filteredProducted.slice(start, end)
    },
    totalPrice: function () {
      let vm = this
      if (vm.voucher) {
        return vm.voucher.lasttotal
      }
      if (vm.filterCart && vm.filterCart.length > 0) {
        let total = 0
        try {
          total = vm.filterCart.reduce(
            (prev, curr) => prev + curr.bundleprice,
            0
          )
        } catch (error) {
          // eslint-disable-next-line no-console
          console.error(error)
        }

        return total
      } else {
        return 0
      }
    },

    isTotalMinimum() {
      if (
        ['324885161495477', '103195847822433'].includes(
          this.pageProfile.pageid
        ) &&
        this.totalPrice < 500
      ) {
        return true
      } else if (
        ['108209024822196'].includes(this.pageProfile.pageid) &&
        this.totalPrice < 100
      ) {
        return true
      } else {
        return false
      }
    },
    minimumPrice() {
      if (
        ['324885161495477', '103195847822433'].includes(
          this.pageProfile.pageid
        ) &&
        this.totalPrice < 500
      ) {
        return 500
      } else if (
        ['108209024822196'].includes(this.pageProfile.pageid) &&
        this.totalPrice < 100
      ) {
        return 100
      } else {
        return false
      }
    },

    isCartOutOfStock: function () {
      return (
        this.filterCart.filter(function (el) {
          if (el.optionDetail == null) {
            return true
          }
          if (parseInt(el.optionDetail[2]) < el.quantity) {
            return true
          }
          return false
        }).length > 0
      )
    },
    isCDS() {
      return (
        this.pageProfile &&
        this.$store.state.cds.includes(this.pageProfile.pageid)
      )
    },
    currentCategory() {
      if (['all', 'sale'].indexOf(this.selectedCategory) != -1) return null
      return this.categories.find((el) => {
        return el.id == this.selectedCategory
      })
    }
  },
  mounted: async function () {
    this.$nextTick(() => {
      window.addEventListener('resize', this.onResize)
    })
    localStorage.removeItem('cartarray')
    let vm = this
    vm.$store.dispatch('deleteAllItemsInCart')
    vm.loadingCart = true
    this.userAgent = navigator.userAgent

    await vm.$store.dispatch('loadPageProfile', {
      pagename: vm.pagename,
      userid: vm.$route.query.userid
    })

    if (this.pageProfile && this.pageProfile.type == 'kanom') {
      this.showShop = true
    }

    vm.hasVoucher = vm.pageProfile.ispromocode

    document.title = vm.pageProfile.pagename
    vm.pageid = vm.pageProfile.pageid
    vm.$store.dispatch('getSalePage', vm.pageid)
    vm.$store.dispatch('updateShopColor', vm.pageProfile.shopcolor)
    vm.$store.dispatch(
      'setLang',
      vm.pageProfile.usershoplang || vm.pageProfile.shoplang
    )
    if (vm.$route.query.userid) {
      vm.userid = vm.$route.query.userid
      // var response_lang = await vm.$store.dispatch("getUserShopLang", {
      //   pageid: vm.pageProfile.pageid,
      //   userid: vm.userid,
      // });
      // if (response_lang) {
      //   vm.$store.dispatch("setLang", response_lang.usershoplang);
      // }
      // var data = {
      //   userid: vm.userid,
      //   pageid: vm.pageProfile.pageid,
      //   lang: vm.currentLang,
      // };
      // vm.$store.dispatch("updatePageProfile", data);
    }
    vm.productLoading = true
    if (vm.pageProfile.wholesale_status === true) {
      // vm.$store.dispatch("getWholeSaleStatus", vm.pageProfile.pageid).then(function() {
      vm.$store.dispatch('getWholeSale', vm.pageProfile.pageid)
      // });
    }
    await vm.getCategories()
    if (vm.$route.query.category) {
      if (vm.$route.query.category === 'all') {
        vm.selectedCategory = 'all'
      } else if (vm.$route.query.category === 'sales') {
        vm.selectedCategory = 'sales'
      } else {
        vm.selectedCategory = 'all'
        if (vm.categories) {
          var found = vm.categories.find(function (cat) {
            return cat.id == vm.$route.query.category
          })
          if (found) {
            vm.selectedCategory = vm.$route.query.category
          }
        }
      }
    } else {
      if (
        ['nvbb'].includes(vm.pageProfile.type) &&
        vm.categories &&
        vm.categories.length > 0
      ) {
        vm.selectedCategory = vm.categories[0].id.toString()
      }
    }
    await vm.getProducts()
    if (vm.$route.query.userid) {
      await vm.getUserCart()
    }
    if (vm.$route.query.pid) {
      var productid = vm.$route.query.pid
      var products = vm.onFilterProducts()

      var productIndex = products.findIndex((product) => {
        return product.id.toString() === productid.toString()
      })

      if (productIndex > -1) {
        await vm.$nextTick()

        vm.pageNumber = Math.ceil((productIndex + 1) / vm.size)

        // vm.selectedCategory = "all";
      }
    }
    if (vm.$route.query.influ) {
      var influ = vm.$route.query.influ
      vm.$store.commit('SET_INFLUENCER_ID', influ)
    } else {
      vm.$store.commit('CLEAR_INFLUENCER_ID')
    }

    if (vm.$route.query.sessiontoken) {
      vm.sessiontoken = vm.$route.query.sessiontoken
    }

    var uri = window.location.toString()
    if (location.hash == '#modal-open') {
      if (uri.indexOf('#') > 0) {
        // var clean_uri = uri.substring(0, uri.indexOf("#"));
        // window.location.href = clean_uri;
        window.location.href.replace('#', '')
        history.replaceState(null, null, window.location.href)
      }
    } else if (location.hash == '#modal-checkout') {
      //console.log("open modal");

      if (uri.indexOf('#') > 0) {
        window.location.href.replace('#', '')
        history.replaceState(null, null, window.location.href)
      }
      this.openModal()
    }

    // window.onscroll = function() {
    //   vm.scrollY = Math.round(window.pageYOffset);
    // };

    // vm.matchCategoryWidth();
    // window.addEventListener("resize", function(e) {
    //   vm.matchCategoryWidth();
    // });

    if (vm.$route.query.view && vm.$route.query.view == 'cart') {
      await vm.$nextTick()
      vm.openModal()
    }

    if (['kanom'].includes(vm.pageProfile.type)) await vm.getbranchlocation()
    vm.loadingmap = false

    await vm.wait(1000)
    vm.loadingCart = false
  },
  components: {
    Message,
    Product,
    ModalCheckout,
    CheckoutItem,
    SyncLoader,
    Loading,
    Modal,
    MerchantDetail,
    TermAndCondition,
    VoucherCode,
    ModalProduct,
    ModalProduct2,
    ModalForexProduct,
    ModalRunkanProduct,
    GmapNearShop
  },
  methods: {
    ready(player) {
      player.target.playVideo()
    },

    clickSelectedCategory(id) {
      this.selectedCategory = `${id}`
      this.pageNumber = 1
    },
    onResize() {
      this.windowWeight = window.innerWeight
    },
    getSalePageTemplate() {
      if (this.getSalePage) {
        this.salePageShopName = this.getSalePage.shop_name
        this.salePage = this.getSalePage.content_json
        this.salePageIsActive = this.getSalePage.is_active
        //fb-pixel implementation
        if (this.getSalePage.fb_pixel) {
          window.fbq('init', this.getSalePage.fb_pixel)
          window.fbq('track', 'PageView')
        }
        //tiktok-pixel implementation
        if (this.getSalePage.tiktok_pixel) {
          var tiktok_pixel =
            this.getSalePage.tiktok_pixel.split(`ttq.load('`)[1]
          tiktok_pixel = tiktok_pixel.split(`')`)
          window.ttq.load(tiktok_pixel[0])
        }
        //analytics-google implementation
        if (this.getSalePage.google_analytics) {
          window.gtag('config', this.getSalePage.google_analytics)
          let googleScript = document.createElement('script')
          googleScript.setAttribute(
            'src',
            `https://www.googletagmanager.com/gtag/js?id=${this.getSalePage.google_analytics}`
          )
          document.head.appendChild(googleScript)
        }

        //google_tag
        if (this.getSalePage.google_tag) {
          var script = document.createElement('script')
          script.onload = (function (w, d, s, l, i) {
            w[l] = w[l] || []
            w[l].push({
              'gtm.start': new Date().getTime(),
              event: 'gtm.js'
            })
            var f = d.getElementsByTagName(s)[0],
              j = d.createElement(s),
              dl = l != 'dataLayer' ? '&l=' + l : ''
            j.async = true
            j.src = 'https://www.googletagmanager.com/gtm.js?id=' + i + dl
            f.parentNode.insertBefore(j, f)
          })(
            window,
            document,
            'script',
            'dataLayer',
            this.getSalePage.google_tag
          )
        }
      }
      this.productLoading = false
    },

    async openCheckout() {
      this.closeProduct()
      await this.$nextTick()
      this.showModal = true
      window.fbq('track', 'Checkout')
      window.ttq.track('Checkout')
      window.gtag('event', 'Checkout')
      window.dataLayer.push({ Checkout: 'Checkout' })
    },
    calshippingpricekanom(distance_km, totalprice) {
      //   var ceiling_distance_km = Math.ceil(distance_km);
      try {
        var ceiling_distance_km = 0
        var decimal = parseFloat((distance_km % 1).toFixed(1))
        distance_km = Math.floor(distance_km)
        if (decimal > 0.4) distance_km += 1
        ceiling_distance_km += distance_km
      } catch (error) {
        return false
      }

      var price = 0
      switch (ceiling_distance_km) {
        case 0:
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
          price = 40
          break
        case 6:
          price = 45
          break
        case 7:
          price = 55
          break
        case 8:
          price = 65
          break
        case 9:
          price = 75
          break
        case 10:
          price = 85
          break
        case 11:
          price = 95
          break
        case 12:
          price = 105
          break
        case 13:
          price = 115
          break
        case 14:
          price = 125
          break
        case 15:
          price = 135
          break
        case 16:
          price = 145
          break
        case 17:
          price = 155
          break
        default:
          return false
      }

      if (this.hasSnackbox && totalprice >= 5000) {
        return 0
      } else if (this.hasSnackbox && totalprice < 5000) {
        return 300
      } else {
        return price
      }
    },
    getbranchlocation() {
      var vm = this
      return new Promise((resolve) => {
        axios
          .get(
            config.getConfig('serverUrl') +
              'branchlocation?pageid=' +
              this.pageid
          )
          .then((response) => {
            if (response.data.responsecode == 200) {
              vm.branchlocation = response.data.branchlocation
              let externalScript = document.createElement('script')
              externalScript.setAttribute(
                'src',
                `https://maps.googleapis.com/maps/api/js?key=${response.data.googlekey}&language=th&libraries=places`
              )
              externalScript.async = true
              externalScript.defer = true
              externalScript.onload = () => {
                vm.showmap = true
                resolve()
              }
              document.head.appendChild(externalScript)
              // resolve();
            }
          })
      })
    },
    gmapLocation() {
      var vm = this
      var locations = []
      var nearestlocation
      var stringlatlng =
        this.gmapvalue ||
        this.gmapvalue.lat.toString() + ',' + this.gmapvalue.lng.toString()
      // eslint-disable-next-line no-undef
      var service = new google.maps.DistanceMatrixService()
      var origins = vm.branchlocation.map((el) => el.lat_long)

      service.getDistanceMatrix(
        {
          origins,
          destinations: [stringlatlng],
          travelMode: 'DRIVING',
          region: 'TH',

          drivingOptions: {
            departureTime: new Date(),
            trafficModel: 'optimistic'
          }
        },
        callback
      )
      function callback(response, status) {
        if (status == 'OK') {
          var bodyjson = response
          for (var i = 0; i < bodyjson.rows.length; i++) {
            var row = bodyjson.rows[i].elements[0].distance

            try {
              locations.push({
                name: vm.branchlocation[i].name,
                distance: parseFloat((row.value / 1000).toFixed(2)),
                pictureurl: vm.branchlocation[i].pictureurl
              })
            } catch (error) {
              //console.error(error);
            }
          }

          locations.sort((a, b) => {
            var x = a.distance
            var y = b.distance
            return x < y ? -1 : x > y ? 1 : 0
          })

          nearestlocation = locations[0]
          vm.shippingAddress = response.destinationAddresses[0]
          vm.placesinfo = response.destinationAddresses[0]
          vm.ggmapdistance = nearestlocation
          var shippingprice = vm.calshippingpricekanom(
            nearestlocation.distance,
            vm.totalincludediscount
          )
          vm.ableToShipping = shippingprice !== false
          vm.kanomshippingprice = vm.ableToShipping ? shippingprice : 0

          if (vm.branchlocation && vm.branchlocation.length > 1) {
            vm.banktransferinfo_photo = nearestlocation.pictureurl
          } else {
            vm.banktransferinfo_photo = vm.mainBankTransferInfoPhoto
          }

          var location_name = vm.shopOptions.find((el) => {
            return el.includes(nearestlocation.name)
          })
          if (location_name) vm.shop = location_name
          // vm.khaiwhanselectedbank = vm.khaiwhanbank.find((el) => el.ref == nearestlocation.name);
        } else {
          // 400
        }
      }
    },

    selectShop() {
      this.$store.dispatch('updateAllCart', this.filterCart)

      this.showShop = false
    },
    wait(time) {
      return new Promise((resolve) =>
        setTimeout(() => {
          resolve()
        }, time)
      )
    },
    showProduct(productid) {
      var product = this.productlist.find((el) => {
        return el.id == productid
      })
      if (product) {
        var newProduct = { ...product }
        newProduct.showBack = true
        this.onSelectProduct(newProduct)
      }
    },
    async onSelectProduct(product) {
      this.currentProduct = product
      await this.$nextTick()

      this.showProductModal = true
      let vm = this
      await this.$nextTick()

      // this.$vuetify.goTo(0, {
      //   duration: 0,
      //   offset: 0,
      //   easing: "linear",
      // });
      window.history.pushState({ modal: 'open' }, '', '#modal-open')
      // window.location.hash = "#modal-open";
      window.onpopstate = function (event) {
        if (event.state && event.state.modal == 'open') {
          // console.log('test')
        } else {
          vm.showProductModal = false
          vm.showModal = false
        }
      }
    },
    async closeProduct() {
      this.showProductModal = false
    },

    onFilterProducts() {
      var vm = this
      let filteredProducted = []
      var productlist = []
      if (this.pageProfile && this.pageProfile.type == 'kanom') {
        productlist = vm.productlist.filter((el) => {
          return (
            this.filterCategory.findIndex((cat) => cat.id == el.categoryid) !=
            -1
          )
        })
      } else {
        productlist = vm.productlist
      }
      if (productlist && vm.selectedCategory == 'sales') {
        productlist.forEach(function (val) {
          if (parseFloat(val.price) > parseFloat(val.discountprice)) {
            filteredProducted.push(val)
          } else {
            var isDiscount = false
            if (val.productstock) {
              val.productstock.map(function (stock) {
                if (parseFloat(stock[3]) > parseFloat(stock[4])) {
                  isDiscount = true
                }
              })
            }

            if (isDiscount) {
              filteredProducted.push(val)
            }
          }
        })
      } else if (productlist && vm.selectedCategory != 'all') {
        filteredProducted = productlist.filter(function (el) {
          return vm.selectedCategory == el.categoryid
        })
      } else {
        filteredProducted = productlist
      }

      if (vm.search != '' && filteredProducted) {
        filteredProducted = filteredProducted.filter((product) => {
          return product.name.toLowerCase().includes(vm.search.toLowerCase())
        })
      }

      filteredProducted.sort(function (a, b) {
        if (a.isOutOfStock && !b.isOutOfStock) {
          return 1
        } else if (!a.isOutOfStock && b.isOutOfStock) {
          return -1
        } else {
          return 0
        }
      })

      return filteredProducted
    },
    onUpdateStock: function () {
      var vm = this
      if (vm.voucher) {
        vm.voucher.onUpdate()
      }
      this.timestamp = moment().format('x')
    },
    onUpdateTotal: function (payload) {
      this.voucher = payload
    },
    matchCategoryWidth: function () {
      let vm = this
      let totalWidth = this.getStyle('#filter #container', 'contentWidth')
      let searchWidth = this.getStyle('#search-btn', 'width')
      // let scrollWidth = document.body.scrollWidth;
      if (!totalWidth || !searchWidth) {
        return false
      }
      // console.log(totalWidth,searchWidth)
      totalWidth = totalWidth - searchWidth - 25
      // console.log($("#categories"),totalWidth)
      vm.categoriesWidth = totalWidth + 'px'
    },
    openModal: function () {
      this.showModal = true
      let vm = this
      window.fbq('track', 'Checkout')
      window.ttq.track('Checkout')
      window.gtag('event', 'Checkout')
      window.dataLayer.push({ Checkout: 'Checkout' })
      window.history.pushState({ modal: 'open' }, '', '#modal-open')
      // window.location.hash = "#modal-open";
      window.onpopstate = function (event) {
        if (event.state && event.state.modal == 'open') {
          // console.log('test')
        } else {
          vm.showModal = false
          vm.showProductModal = false
        }
      }
    },
    close: function () {
      var vm = this

      vm.showModal = false
      if (window.history.length == 0) {
        //
      } else {
        window.history.back()
      }
    },
    closeTerm: function () {
      var vm = this
      if (window.history.length == 0) {
        vm.showTerm = false
      } else {
        window.history.back()
      }
    },
    getUserCart() {
      let vm = this
      return new Promise(async (resolve) => {
        vm.$store.dispatch('deleteAllItemsInCart')
        try {
          var response = await axios.post(
            `${config.getConfig('serverUrl')}v2/usercart`,
            {},
            {
              params: {
                pageid: vm.pageid,
                userid: vm.userid
              }
            }
          )

          // JSON responses are automatically parsed.
          response = response.data
          if (response.responsecode == 200) {
            let data = response.result
            // vm.$store.dispatch('setCart',response.cartarray)
            vm.$store.commit('SET_CART_ID', data.cart_ids || [])
            if (data.cartarray) {
              var product_id_list = []
              var products = []

              products = data.cartarray.map(function (val) {
                product_id_list.push(val.productid)
                var option = null
                var productIndex = vm.allproducts.findIndex((el) => {
                  return el.id == val.productid
                })
                if (productIndex != -1) {
                  var stock = vm.allproducts[productIndex].productstock

                  option = stock.find(function (el) {
                    if (['khaiwhan', 'gaigao'].includes(vm.pageProfile.type)) {
                      if (val.option != 'Normal') {
                        return el[1] == val.option.split(' - ')[0]
                      } else {
                        return el[1] == 'Normal'
                      }
                    } else {
                      return el[1] == val.option
                    }
                  })
                }
                return {
                  ...val,
                  id: val.productid,
                  price: parseFloat(val.price),
                  discountprice: parseFloat(val.discountprice),
                  optionDetail: option
                }
              })

              if (products.length > 0) {
                vm.$store.commit('SET_ALL_CART', products)
                // for (let index = 0; index < products.length; index++) {
                //   await vm.$store.dispatch("addToCart", products[index]);
                // }
                let url =
                  config.getConfig('serverUrl') +
                  'productbundle?productid=' +
                  product_id_list.join(',')
                var bundle_response = await axios.get(url)
                bundle_response = bundle_response.data

                if (
                  bundle_response.responsecode == 200 &&
                  bundle_response.productbundlelist.length > 0
                ) {
                  vm.$store.commit(
                    'UPDATE_BUNDLE_CART',
                    bundle_response.productbundlelist
                  )
                }
              }
            }

            // if (response.promocode) {
            //   vm.voucherCode = response.promocode;
            // }
            resolve()
          } else if (
            response.responsecode == 400 &&
            response.reason == 'CART_NOT_FOUND'
          ) {
            // console.log(response);
            resolve()
          }
        } catch (error) {
          // eslint-disable-next-line no-console
          console.error(error)
        }
      })
    },
    getProducts() {
      let vm = this
      return new Promise((resolve, reject) => {
        var data = {
          pageid: vm.pageid,
          userid: vm.userid
        }
        if (
          vm.pageProfile &&
          vm.pageProfile.useketshop == true &&
          vm.pageProfile.ketshop_api_key &&
          vm.pageProfile.ketshop_api_secret
        ) {
          data['ketshop_api_key'] = vm.pageProfile.ketshop_api_key
          data['ketshop_api_secret'] = vm.pageProfile.ketshop_api_secret
        }
        axios
          .get(config.getConfig('serverUrl') + 'products', {
            params: data
          })
          .then((response) => {
            // JSON responses are automatically parsed.
            response = response.data
            if (response.responsecode == 200) {
              vm.products = {}
              var products = response.productlist.filter((el) => {
                // console.log(el.status);
                return el.status == true
              })

              var result = vm.formatProducts(products, vm.categories)
              var allresult = vm.formatProducts(response.productlist)
              vm.products = allresult.product_by_index

              vm.productlist = result.products
              vm.allproducts = allresult.products

              vm.hasSaleCategory = false

              vm.productlist.map((val) => {
                if (parseFloat(val.price) > parseFloat(val.discountprice)) {
                  vm.hasSaleCategory = true
                } else {
                  var isDiscount = false
                  if (val.productstock) {
                    val.productstock.map(function (stock) {
                      if (parseFloat(stock[3]) > parseFloat(stock[4])) {
                        isDiscount = true
                      }
                    })
                  }

                  if (isDiscount) {
                    vm.hasSaleCategory = true
                  }
                }
              })
              let a = []
              vm.productlist.filter((product) => {
                return vm.categories.map((category) => {
                  if (
                    product.categoryid === category.id &&
                    !category.is_hidden
                  ) {
                    a.push(product)
                  }
                })
              })
              vm.productlist = a
              resolve()
            } else {
              // console.log(response);
              reject()
            }
            vm.getSalePageTemplate()
          })
          .catch(() => {
            vm.productLoading = false
            reject()
          })
      })
    },
    getCategories() {
      let vm = this
      return new Promise((resolve, reject) => {
        var data = {
          pageid: vm.pageid
        }
        if (
          vm.pageProfile &&
          vm.pageProfile.useketshop == true &&
          vm.pageProfile.ketshop_api_key &&
          vm.pageProfile.ketshop_api_secret
        ) {
          data['ketshop_api_key'] = vm.pageProfile.ketshop_api_key
          data['ketshop_api_secret'] = vm.pageProfile.ketshop_api_secret
        }
        axios
          .get(config.getConfig('serverUrl') + 'categories', {
            params: data
          })
          .then((response) => {
            // JSON responses are automatically parsed.
            response = response.data
            if (response.responsecode == 200) {
              vm.categories = []
              try {
                vm.categories = response.categorylist.map((category) => {
                  var c = category
                  c.productCount = 0
                  return c
                })
              } catch (error) {
                //
              }

              resolve()
            } else {
              reject()
            }
          })
      })
    },
    checkout: async function (isClose) {
      const vm = this
      window.fbq('track', 'ProceedCheckout')
      window.ttq.track('ProceedCheckout')
      window.gtag('event', 'ProceedCheckout')
      window.dataLayer.push({ ProceedCheckout: 'ProceedCheckout' })
      let isSkip = !['cds'].includes(vm.pageProfile.type)
      if (
        vm.pageProfile &&
        vm.pageProfile.useketshop == true &&
        vm.pageProfile.ketshop_api_key &&
        vm.pageProfile.ketshop_api_secret
      ) {
        isSkip = false
      }

      isClose = isClose ? isClose : false
      return new Promise(async (resolve) => {
        if (!vm.filterCart) {
          return false
        }
        vm.checkoutLoading = true
        let data = {
          cartarray: [],
          type: 'salepage'
        }

        data.cartarray = vm.filterCart.map((val) => {
          let quantity = 1
          if (this.pageProfile.theme == 'runkan') {
            quantity = 1
          } else {
            quantity = val.quantity
          }
          let option = {
            pid: val.id,
            qty: quantity,
            option: val.option,
            cart_remark: val.cart_remark
            // photourl: val.photourl,
          }
          if (
            vm.pageProfile &&
            vm.pageProfile.useketshop == true &&
            vm.pageProfile.ketshop_api_key &&
            vm.pageProfile.ketshop_api_secret
          ) {
            option['ketshop_option'] = val.optionid
          }

          return option
        })

        let url = config.getConfig('serverUrl') + 'addproductstocart_array'
        var params = {
          pageid: vm.pageid
        }
        if (this.$route.query.group_id) {
          data.group_id = this.$route.query.group_id
        }
        if (vm.userid != null && vm.userid != '') {
          params.userid = vm.userid
        }

        if (vm.sessiontoken != null && vm.sessiontoken != '') {
          params.sessiontoken = vm.sessiontoken
        }

        if (vm.voucher) {
          data.promocode = vm.voucher.promocode
        }
        if (vm.$route.query.from) {
          data.from = vm.$route.query.from
        } else {
          try {
            var device = vm.$liff.getOS()
            var version = vm.$liff.getVersion()
            await vm.$liff.ready

            if (
              vm.userid &&
              vm.userid.indexOf('__') != -1 &&
              device &&
              version &&
              !vm.$liff.isInClient()
            ) {
              data.from = 'livechat'
            }
          } catch (error) {
            // eslint-disable-next-line
            console.log(error)
          }
        }

        if (vm.$route.query.admintoken) {
          data.admin_jwt = vm.$route.query.admintoken
          if (this.$route.query.adminpromocode) {
            data.promocode = this.$route.query.adminpromocode
          }
        }

        try {
          var response = await axios.post(url, data, {
            params: params
          })

          response = response.data

          if (response.responsecode == 200) {
            if (isClose) {
              // eslint-disable-next-line
              if (vm.$liff.isInClient() && vm.pageProfile.type !== 'runkan') {
                // eslint-disable-next-line
                try {
                  await vm.$liff.sendMessages([
                    {
                      type: 'text',
                      text: vm.$t('Cart Summary')
                    }
                  ])
                } catch (error) {
                  // eslint-disable-next-line no-console
                  console.error(error)
                }

                // eslint-disable-next-line

                try {
                  if (isSkip) {
                    var query_string = []
                    var query_string_from_url = vm.$route.query
                    delete query_string_from_url.view
                    query_string_from_url.lang = this.currentLang

                    for (const query_name in query_string_from_url) {
                      query_string.push(
                        `${query_name}=${query_string_from_url[query_name]}`
                      )
                    }

                    if (this.$route.query.app == 'line') {
                      this.$route.query.id = vm.pageProfile.pageid
                      this.$route.query.lang = this.currentLang
                      this.$store.state.view = 'transfer'
                    } else {
                      this.$router.push({
                        name: 'transfer',
                        params: { id: this.pageProfile.pageid },
                        query: { ...this.$route.query, lang: this.currentLang }
                      })
                    }

                    // vm.$liff.closeWindow();
                  } else {
                    vm.$liff.closeWindow()
                  }
                } catch (error) {
                  //
                }
              } else {
                if (vm.$liff.isInClient()) {
                  try {
                    await vm.$liff.sendMessages([
                      {
                        type: 'text',
                        text: vm.$t('Cart Summary')
                      }
                    ])
                  } catch (error) {
                    // eslint-disable-next-line no-console
                    console.error(error)
                  }
                }
                // eslint-disable-next-line

                if (isSkip) {
                  if (this.$route.query.app == 'line') {
                    this.$route.query.id = vm.pageProfile.pageid
                    this.$route.query.lang = this.currentLang
                    this.$store.state.view = 'transfer'
                  } else {
                    vm.$router.push({
                      name: 'transfer',
                      params: { id: vm.pageProfile.pageid },
                      query: { ...this.$route.query, lang: this.currentLang }
                    })
                  }
                } else {
                  // eslint-disable-next-line no-undef
                  MessengerExtensions.requestCloseBrowser(
                    function success() {},
                    function error() {
                      window.close()
                    }
                  )
                }
              }
            }
          } else if (response.responsecode == 201) {
            localStorage.setItem('cartarray', JSON.stringify(vm.filterCart))
            if (isSkip) {
              if (this.$route.query.app == 'line') {
                this.$route.query.id = vm.pageProfile.pageid
                this.$store.state.view = 'transfer'
              } else {
                vm.$router.push({
                  name: 'transfer',
                  params: { id: vm.pageProfile.pageid }
                })
              }
            } else {
              // eslint-disable-next-line no-undef
              MessengerExtensions.requestCloseBrowser(
                function success() {},
                function error() {
                  window.close()
                }
              )
            }
          } else {
            vm.$swal({
              title: vm.$t('Error'),
              text: vm.$t('Something went wrong. Please try it again.'),
              type: 'error',
              confirmButtonText: vm.$t('Confirm'),
              cancelButtonText: vm.$t('cancel'),
              reverseButtons: true
            })
            // eslint-disable-next-line
            if (vm.$liff.isInClient()) {
              // eslint-disable-next-line no-undef
              vm.$liff.closeWindow()
            } else {
              // eslint-disable-next-line
              MessengerExtensions.requestCloseBrowser(
                function success() {},
                function error() {
                  window.close()
                }
              )
            }
          }

          vm.checkoutLoading = false

          await this.$store.dispatch('deleteAllItemsInCart')
          resolve()
        } catch (error) {
          vm.checkoutLoading = false
          vm.close()
          vm.$swal({
            title: vm.$t('Error'),
            text: vm.$t('Something went wrong. Please try it again.'),
            type: 'error',
            confirmButtonText: vm.$t('Confirm'),
            cancelButtonText: vm.$t('cancel'),
            reverseButtons: true
          })
        }
      })
    },
    addToCart: async function ({ item, loading }) {
      // var product = payload.product;
      if (
        this.pageProfile.type == 'chillpainai' &&
        this.$store.state.influencerid
      ) {
        item.cart_remark = this.$store.state.influencerid
      }
      if (['chillpainai', 'runkan'].includes(this.pageProfile.type)) {
        this.$store.dispatch('deleteAllItemsInCart')
      }
      let tmp = {
        ...item,
        optionid: item.option[0],
        option: item.option[1],
        max: item.option[2],
        productid: item.id,
        optionDetail: item.option
      }
      let vm = this

      await this.$store.dispatch('addToCart', { product: tmp })
      if (vm.voucher) {
        vm.voucher.onUpdate()
      }
      if (
        vm.isCDS ||
        ['rabbit', 'chillpainai', 'runkan'].includes(vm.pageProfile.type)
      ) {
        await vm.checkout(true)
      } else if (['forex'].includes(vm.pageProfile.type)) {
        await vm.checkout(false)
      } else {
        //
      }
      if (loading) {
        loading()
      }
    },
    openNewtab(url) {
      if (url) {
        window.open(url, '_blank')
      }
    },
    deleteItemInCart: function (item) {
      var vm = this
      vm.deleteIndex = item.rand_id
      // this.showDelete = true;
      vm.$swal({
        title: vm.$t('Do you want to remove this') + '?',

        type: 'warning',
        showCancelButton: true,
        confirmButtonText: vm.$t('Confirm'),
        cancelButtonText: vm.$t('Cancel'),
        reverseButtons: true
      }).then(function (result) {
        if (result.value) {
          vm.$store.dispatch('deleteFromCart', item.rand_id)
        }
        if (vm.voucher) {
          vm.voucher.onUpdate()
        }
      })
    },
    onDeleteItem: function () {
      if (this.deleteIndex != null) {
        this.$store.dispatch('deleteFromCart', this.deleteIndex)
      }
      this.showDelete = false
    },
    openTerm: function () {
      this.showTerm = true
      let vm = this
      window.history.pushState({ modal: 'open' }, '', '#modal-open')
      // window.location.hash = "#modal-open";
      window.onpopstate = function (event) {
        if (event.state && event.state.modal == 'open') {
          // console.log('test')
        } else {
          vm.showTerm = false
        }
      }
      // window.location.hash = "#modal-open";
      // window.onpopstate = function() {
      //   if (location.hash == "#modal-open") {
      //     // console.log("test");
      //   } else {
      //     vm.showTerm = false;
      //   }
      // };
    },
    openSearch: function () {
      let vm = this
      vm.showSearch = !vm.showSearch
      if (vm.showSearch) {
        this.$nextTick(() => vm.$refs.searchProduct[0].focus())
      } else {
        vm.search = ''
      }
    },
    onChangeCategory: function () {
      this.pageNumber = 1
    },
    filterProductsList(list) {
      var value = this.productlist.filter(
        function (e) {
          return this.indexOf(e.id) >= 0
        },
        typeof list == 'number' || list == 'string' ? [list] : list
      )
      return value
    }
  },
  watch: {
    showModal: function (newVal) {
      if (newVal) {
        this.addClass('body', 'modal-open')
      } else {
        this.removeClass('body', 'modal-open')
      }
    },
    // currentCategory: function(newVal) {
    //   if (newVal != null) {
    //     this.getProducts();
    //   }
    // },
    search: function (newVal, oldVal) {
      if (newVal !== oldVal) {
        this.pageNumber = 1
      }
    },
    pageNumber: function (newVal, oldVal) {
      if (newVal != oldVal) {
        // this.$vuetify.goTo(0, {
        //   duration: 300,
        //   offset: 0,
        //   easing: "linear",
        // });
      }
    }
  }
}
</script>

<style lang="scss">
.z-border-red {
  border: 1px solid;
  border-radius: 10px;
  border-bottom-right-radius: 0px;
  margin-bottom: 5px;
  padding: 10px 0;
}
.v-tabs__item--active {
}
</style>
